import React  from 'react';
import styles from './Login.module.css';
import Button from "react-bootstrap/Button";
import { useHistory } from "react-router-dom";
import { signInWithSocialLogin } from '../../../services/Auth.service';
import { createUser, logOut } from '../../../services/User.service';
import { setUserSelector } from '../../../hooks/store/setters';
import { useAppStore } from '../../../hooks/store/useAppStore';
import { setAlertMessageSelector } from '../../../hooks/store/setters';
import Logo from '../logo/Logo';
import { SiGoogle, SiMicrosoft, SiApple } from "react-icons/si";
import { setLoaderSelector } from './../../../hooks/store/setters';
import { getUser } from '../../../services/User.service';
import { GoogleAuthProvider, MicrosoftAuthProvider } from '../../../providers/SocialAuthProvider';
import { updateUserLastSignedIn } from './../../../services/User.service';
import { getAppConfig } from '../../../services/AppConfig.service';

export default function Login() {
 
 const history = useHistory();
 
  const setUser = useAppStore(setUserSelector);
  const setAlertMessage = useAppStore(setAlertMessageSelector);
  const setLoader = useAppStore(setLoaderSelector);

  
  const forceLogoutAndPreventUserLogin = (alertMsg) => {
    logOut();
    setAlertMessage(alertMsg);
    setLoader(false);
  }
  

  const socialSignin = async (provider) => {
   
    try{
      setLoader("Authenticating...");
      
      const user = await signInWithSocialLogin(provider);
      let userData = await getUser(user.uid);
      console.log('userData',userData);

      if(!userData) {
        
        const appConfig = await getAppConfig()
        console.log('app config', appConfig)
        if (!appConfig.enableNewUserSignIn) {
          return forceLogoutAndPreventUserLogin("User not found. Please contact admin.");
        }
                
        await createUser(user);
        userData = await getUser(user.uid);
      
      } else {
        if (userData.isDisabled) {
          return forceLogoutAndPreventUserLogin("Account is suspended. Please contact admin.");
        } else {
          await updateUserLastSignedIn(user)
        }
      }
      
      setUser(userData);
      history.push("/");
      
    } catch(error) {
      console.log('error',error);
      setAlertMessage("Error while logging");
    }
    
    setLoader(false);
   
  }
  
  
  
  return (
    <section className={styles.loginContainer}>
      <div className={styles.loginLogo}>
        <Logo />
      </div>
      
      <div className={styles.loginBtnsWrapper}>
        <h2 className={styles.loginHeader}>Login to continue</h2>
        
        <Button className={styles.loginBtn}      
          variant="warning" 
          onClick={() => socialSignin(GoogleAuthProvider)}
        >
          <SiGoogle className={styles.loginBtnIcon} />
          Login With Google 
        </Button>
        
        <Button className={styles.loginBtn}      
          variant="danger" 
          onClick={() => socialSignin(MicrosoftAuthProvider)}
        >
          <SiMicrosoft className={styles.loginBtnIcon} />
          Login With Microsoft 
        </Button>
        
        <Button className={styles.loginBtn}      
          variant="dark" 
          onClick={() => socialSignin()}
        >
          <SiApple className={styles.loginBtnIcon} />
          Login With Apple 
        </Button>
      </div>
    </section>
  )
}